module.exports = __webpack_public_path__ + "img/11.c44ef27b.jpg";